import { render, staticRenderFns } from "./customerCustomization.vue?vue&type=template&id=7546c153&"
import script from "./customerCustomization.vue?vue&type=script&lang=js&"
export * from "./customerCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7546c153')) {
      api.createRecord('7546c153', component.options)
    } else {
      api.reload('7546c153', component.options)
    }
    module.hot.accept("./customerCustomization.vue?vue&type=template&id=7546c153&", function () {
      api.rerender('7546c153', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/customerCustomization.vue"
export default component.exports